import { render, staticRenderFns } from "./competitionCalendar.vue?vue&type=template&id=0588b216&scoped=true"
import script from "./competitionCalendar.vue?vue&type=script&lang=js"
export * from "./competitionCalendar.vue?vue&type=script&lang=js"
import style0 from "./competitionCalendar.vue?vue&type=style&index=0&id=0588b216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0588b216",
  null
  
)

export default component.exports